import customerConfig from 'customer/config'
import CustomerListColumnModel from '../../../modules/customer/components/list/models/customer-list-column-model'
import { sanitizeListColumns } from '../../util/sanitizeListColumns'
import request from '@/modules/base/util/request'

// actions
const FINSIHED_FETCHING_CUSTOMER_LIST_SETTING = 'FINSIHED_FETCHING_CUSTOMER_LIST_SETTING'
const ERROR_FETCHING_CUSTOMER_LIST_SETTING = 'ERROR_FETCHING_CUSTOMER_LIST_SETTING'
const SHOW_CUSTOMERS_LOADER = 'SHOW_LOADER'
const HIDE_CUSTOMERS_LOADER = 'HIDE_LOADER'
const SET_CUSTOMER_LIST_ITEMS = 'SET_CUSTOMER_LIST_ITEMS'
const SET_CUSTOMERS_PAGINATION = 'SET_CUSTOMERS_PAGINATION'
const SET_CUSTOMER_SEARCH_TERM = 'SET_CUSTOMER_SEARCH_TERM'
const REFRESH_CUSTOMERS = 'REFRESH_CUSTOMERS'
const STOP_REFRESHING_CUSTOMERS = 'STOP_REFRESHING_CUSTOMERS'

// reducer
const initialState = {
  isLoading: true,
  error: null,
  items: [],
  setting: {
    columns: [],
  },
  searchTerm: '',
  pagination: {
    offset: 0, // current starting point in list
    count: 0, // count of filtered customers
    totalCount: 0, // count of all customers
    limit: 20, // max customers on page
  },
  shouldRefresh: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FINSIHED_FETCHING_CUSTOMER_LIST_SETTING:
      const { setting } = action
      return Object.assign({}, state, {
        error: null,
        setting,
      })

    case SHOW_CUSTOMERS_LOADER:
      return Object.assign({}, state, {
        isLoading: true,
      })

    case HIDE_CUSTOMERS_LOADER:
      return Object.assign({}, state, {
        isLoading: false,
      })

    case SET_CUSTOMER_LIST_ITEMS:
      const { customers } = action
      return Object.assign({}, state, {
        items: customers,
      })

    case SET_CUSTOMERS_PAGINATION:
      const { pagination } = action
      const updatedPagination = Object.assign({}, state.pagination, pagination)
      return Object.assign({}, state, { pagination: updatedPagination })

    case SET_CUSTOMER_SEARCH_TERM:
      const { searchTerm } = action
      return Object.assign({}, state, {
        searchTerm,
      })

    case REFRESH_CUSTOMERS:
      return Object.assign({}, state, {
        shouldRefresh: true,
      })

    case STOP_REFRESHING_CUSTOMERS:
      return Object.assign({}, state, {
        shouldRefresh: false,
      })

    case ERROR_FETCHING_CUSTOMER_LIST_SETTING:
      const { error } = action
      return Object.assign({}, state, {
        isLoading: false,
        error,
      })

    default:
      return state
  }
};

// action creators
export const showLoader = () => {
  return {
    type: SHOW_CUSTOMERS_LOADER,
  }
}

export const hideLoader = () => {
  return {
    type: HIDE_CUSTOMERS_LOADER,
  }
}

export const setCustomerListItems = (customers) => {
  return {
    type: SET_CUSTOMER_LIST_ITEMS,
    customers,
  }
}

export const refreshList = () => {
  return {
    type: REFRESH_CUSTOMERS,
  }
}

export const stopRefreshingList = () => {
  return {
    type: STOP_REFRESHING_CUSTOMERS,
  }
}

export const setPagination = (pagination) => {
  return {
    type: SET_CUSTOMERS_PAGINATION,
    pagination,
  }
}

export const setSearchTerm = (searchTerm) => {
  return {
    type: SET_CUSTOMER_SEARCH_TERM,
    searchTerm,
  }
}

const finishedFetchingCustomerListSetting = (setting) => {
  return {
    type: FINSIHED_FETCHING_CUSTOMER_LIST_SETTING,
    setting,
  }
}

const errorFetchingCustomerListSetting = (error) => {
  return {
    type: ERROR_FETCHING_CUSTOMER_LIST_SETTING,
    error,
  }
}

export const fetchCustomerListSetting = () => {
  return (dispatch) => {
    request(customerConfig.customerListSetting, { auth: true, isConcurrent: true })
      .then((response) => {
        const {
          body: {
            data: { columns },
            meta: {
              defaultSort,
              sortBy,
            },
          },
        } = response

        const sanitizedColumns = sanitizeListColumns(columns, defaultSort, sortBy)
        const customerColumns = sanitizedColumns.map((column) => {
          column.displayed = true
          return new CustomerListColumnModel(column)
        })
        dispatch(finishedFetchingCustomerListSetting({ columns: customerColumns }))
      })
      .catch((error) => dispatch(errorFetchingCustomerListSetting(error)))
  }
}
